import { hslToColorString, parseToHsl } from 'polished';

/**
 * Inverts the luminance of a color in the HSL color space
 *
 * @param color: string - color to invert luminance
 */
export const invertLuminance = color => {
  const colorHsl = parseToHsl(color);
  return hslToColorString({
    hue: colorHsl.hue,
    saturation: colorHsl.saturation,
    lightness: 1 - colorHsl.lightness
  });
};
//# sourceMappingURL=invertLuminance.js.map